import React, { useEffect, useState } from "react";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import AccountSummaryBg from "./img/accountsummarybg.svg";
import E_PostpaidAccountSummary from "./e_postpaid_account_summary/e_postpaid_account_summary";
import E_PrepaidpaidAccountSummary from "./e_prepaid_account_summary/e_prepaid_account_summary";
import { getAssetUrl } from "./model/service";
import E_LASTRECHARGE from "./e_prepaid_account_summary/view/_last_recharge";

const useStyle = makeStyles({
  bgImgStyle: {
    // height: "100%",
    width: "-webkit-fill-available",
    objectFit: "cover",
    backgroundSize: "cover !important",
    padding: "0% !important",
    overflow: "hidden !important",
    borderRadius:"0px",
    height:'100%'
  },
});

export default function E_AccountSummary() {
  let classes = useStyle();
  let [assetInfo, setAssetInfo] = useState();
  let isPrepaid = useSelector(
    (store) => store?.meterDetails?.getSaInfo?.isPrepaidSa
  );
  let backgroundImage = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup
        ?.E_ACCOUNTSUMMARY_BACKGROUND_IMAGE
  );

  useEffect(() => {
    getAssetUrl(backgroundImage).then((res) => setAssetInfo(res))
    .catch(err => setAssetInfo(null))
  }, [backgroundImage]);

  return (
    <>
    <Paper
      className={classes.bgImgStyle}
      style={{
        background: `url(${assetInfo ? assetInfo.assetPath : AccountSummaryBg
        })top center no-repeat`,
      }}
    >
      {isPrepaid === "N" ? (
        <E_PostpaidAccountSummary />
      ) : (
        <E_PrepaidpaidAccountSummary />
      )}
    {/* {isPrepaid === "Y" && < E_LASTRECHARGE/>} */}
    </Paper>
   </>
  );
}
